import Alert from "./alert";
import EmailGroup from "./emailGroup";
import Option from "./option";

export enum AlertDeliveryTypes {
  Email = 1,
  Site,
  SvPro,
  Text,
  Gmd,
  Responder,
  Investigator,
}

export default interface AlertDelivery {
  id?: number;
  alert?: Alert;
  deliveryMethod: Option;
  methodSubtype?: AlertDeliveryTypes;
  sent: boolean;
  read?: boolean;
  emailGroups?: EmailGroup[];
  gmdJobType?: Option;
  responderIncidentType?: Option;
  investigatorCaseType?: Option;
}
